import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_146: FaireProductEntity = {
  token: "legacy_prod_abbott-146",
  type: "product",
  name: "Candy Jar with Lid-8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/23b27a1fb14868f0547b2ffb45831afd3c1ceaa39b30c7258b94e2d2d359dc71.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
